import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import "./index.scss";

function ConfirmModal({
  visible = false,
  onClose = () => {},
  onConfirm = () => {},
  onCountdownComplete = () => {},
  headerHtml = "",
  headerComponent = null,
  imageUrl = "",
  imgWidth = "auto",
  imgHeight = "auto",
  title = "",
  message = "",
  width = 320,
  confirmText = "确认",
  cancelText = "取消",
  countdownText = "倒计时",
  showConfirmButton = true,
  showCancelButton = true,
  showCountdownButton = false,
  confirmButtonType = "primary", // primary 或 warning
  countdownSeconds = 5,
}) {
  const [countdown, setCountdown] = useState(countdownSeconds);

  useEffect(() => {
    let timer;
    if (visible && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      onCountdownComplete();
    }
    return () => clearTimeout(timer);
  }, [visible, countdown, onCountdownComplete]);

  useEffect(() => {
    if (visible) {
      setCountdown(countdownSeconds);
    }
  }, [visible, countdownSeconds]);

  return (
    <Modal
      width={width}
      open={visible}
      onCancel={onClose} // 点击外围关闭
      footer={null} // 不显示默认的确认和取消按钮
      closable={false}
      centered
    >
      <div className="modal-content">
        {headerComponent && (
          <div className="header-component">{headerComponent}</div>
        )}
        {headerHtml && (
          <div
            className="header-html"
            dangerouslySetInnerHTML={{ __html: headerHtml }}
          ></div>
        )}
        {imageUrl && (
          <img
            className="icons"
            src={imageUrl}
            alt="confirm icon"
            style={{ width: imgWidth, height: imgHeight }}
          />
        )}
        {title && <span className="title sys-article-subtitle">{title}</span>}
        {message && (
          <div
            className="content sys-regular-font"
            dangerouslySetInnerHTML={{ __html: message }}
          ></div>
        )}

        {(showConfirmButton || showCancelButton || showCountdownButton) && (
          <div className="btn-group">
            {showConfirmButton && (
              <div
                className={
                  confirmButtonType === "primary"
                    ? "primary-btn"
                    : "warning-btn"
                }
                onClick={onConfirm}
              >
                {confirmText}
              </div>
            )}
            {showCountdownButton && (
              <div className="countdown-btn" onClick={onCountdownComplete}>
                {countdownText} ({countdown}s)
              </div>
            )}
            {showCancelButton && (
              <div className="cancel-btn" onClick={onClose}>
                {cancelText}
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}

export default ConfirmModal;
